import {DomainMarketCode, getMarketCode} from './domainConstants';

export const SimTypeCode = Object.freeze({
  SIM: Object.freeze({
    [DomainMarketCode.CELLCOM]: 'SIM',
    [DomainMarketCode.GOLAN]: 'SIMG',
  }),
  ESIM: Object.freeze({
    [DomainMarketCode.CELLCOM]: 'ESIMP',
    [DomainMarketCode.GOLAN]: 'ESIMG',
  }),
});

const getCurrentMarketCode = () => getMarketCode() || DomainMarketCode.CELLCOM;

export const getSimTypeCode = () => SimTypeCode.SIM[getCurrentMarketCode()];

export const getEsimTypeCode = () => SimTypeCode.ESIM[getCurrentMarketCode()];

export const isSimType = (simType) =>
  simType === SimTypeCode.SIM[DomainMarketCode.CELLCOM] || simType === SimTypeCode.SIM[DomainMarketCode.GOLAN];

export const isEsimType = (simType) =>
  simType === SimTypeCode.ESIM[DomainMarketCode.CELLCOM] || simType === SimTypeCode.ESIM[DomainMarketCode.GOLAN];
